import { render } from "./propertiesDate.vue?vue&type=template&id=57a601e5"
import script from "./propertiesDate.vue?vue&type=script&lang=js"
export * from "./propertiesDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__